import React from "react";
import { Modal } from "react-bootstrap";
import logoGarantia from "../img/aiggo_garantia.png";
import successCheck from "../img/success-check.jpg";

const SuccessModal = ({ showModal, onHideModal }) => {
  return (
    <Modal show={showModal} centered backdrop='static' keyboard={false}>
      <Modal.Body className='garantia-success-modal'>
        <div className='d-flex flex-column mr-5'>
          <div className='d-flex flex-row justify-content-between'>
            <img src={logoGarantia} alt='' style={{ height: "113px" }} />
            <div className='align-self-center' style={{ height: "30px", width: "30px" }}>
              <button
                className='d-flex flex-column justify-content-center h-100'
                onClick={onHideModal}
                style={{
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}>
                <i className='pi pi-times' />
              </button>
            </div>
          </div>
          <div className='text-center my-5'>
            <img src={successCheck} alt='' style={{ width: "82px" }} />
          </div>
          <p
            className='font-futura-medium font-weight-bold ml-5'
            style={{
              fontSize: "22.5px",
              lineHeight: "1.62",
            }}>
            Gracias por compartir tus datos en breve recibirás en tu correo electrónico el
            certificado de tu programa de protección adquirido
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
